import {
  PRODUCT_LIST_GET,
  SUITE_LIST_GET,
  PRODUCT_CATEGORY_GET,
  PRODUCT_DETAIL_GET,
  PRODUCT_SUITE_GET,
  SOLUTION_LIST_GET,
  SOLUTION_DETAIL_GET,
  PRODUCT_CLASSIFY_LIST_GET,
  PRODUCT_MAJOR_UPGRADE_LIST_GET,
  PRODUCT_CHANGE_LIST_GET,
  PRODUCT_PROMOTION_LIST_GET,
  SOLUTION_LV_ONE_LIST_GET,
  SOLUTION_LV_TWO_LIST_GET,
  SOLUTION_HISTORY_GET,
  PRODUCT_CASE_AREA_GET,
  PRODUCT_DETAIL_NOW_GET,
  SHIPMENT_BARCODE_LIST_GET,
  SYSTEM_PRODUCT_LINE_LIST_GET,
  PRODUCT_CATEGORY_SUB_LIST_GET,
} from "../../fetch/url";
import { curl } from "zh-common-modules";
import { get } from "../../fetch/fetch";
import { actionTypes } from "./constants";

export const setProductList = (data) => ({
  type: actionTypes.SET_PRODUCT_LIST,
  data,
});

export const setProductDetail = (data) => ({
  type: actionTypes.SET_PRODUCT_DETAIL,
  data,
});

export const setSuiteList = (data) => ({
  type: actionTypes.SET_SUITE_LIST,
  data,
});

export const setCategoryList = (data) => ({
  type: actionTypes.SET_CATEGORY_LIST,
  data,
});

export const setProductSuite = (data) => ({
  type: actionTypes.SET_PRODUCT_SUITE,
  data,
});

export const setSolutions = (data) => ({
  type: actionTypes.SET_SOLUTION,
  data,
});

export const setCases = (data) => ({
  type: actionTypes.SET_CASE,
  data,
});

export const setSolutionList = (data) => ({
  type: actionTypes.SET_SOLUTION_LIST,
  data,
});

export const setSolutionDetail = (data) => ({
  type: actionTypes.SET_SOLUTION_DETAIL,
  data,
});

export const setProductClassifyList = (data) => ({
  type: actionTypes.SET_PRODUCT_CLASSIFY_LIST,
  data,
});

export const setMajorUpgradeList = (data) => ({
  type: actionTypes.SET_MAJOR_UPGRADE_LIST,
  data,
});

export const setProjectChangeList = (data) => ({
  type: actionTypes.SET_PROJECT_CHANGE_LIST,
  data,
});

export const setPromotionList = (data) => ({
  type: actionTypes.SET_PROMOTION_LIST,
  data,
});

export const setSavePageInfo = (data) => ({
  type: actionTypes.SET_SAVE_PAGE_INFO,
  data,
});

export const setSolutionLevelOne = (data) => ({
  type: actionTypes.SET_SOLUTION_LEVEL_ONE,
  data,
});

export const setSolutionLevelTwo = (data) => ({
  type: actionTypes.SET_SOLUTION_LEVEL_TWO,
  data,
});

export const setSolutionHistory = (data) => ({
  type: actionTypes.SET_SOLUTION_HISTORY_SET,
  data,
});

export const setProductCaseAreaList = (data) => ({
  type: actionTypes.SET_PRODUCT_CASE_AREA_LIST,
  data,
});

export const setMessage = (data) => ({
  type: actionTypes.SET_MESSAGE,
  data,
});

export const getProductDetail = (params, cb) => {
  return (dispatch) => {
    get(PRODUCT_DETAIL_GET, params)
      .then((res) => {
        if (res.success) {
          const data = res.content;
          cb && cb(data);
          dispatch(setProductDetail(data));
        }
      })
      .catch((error) => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取产品详情失败",
          })
        );
        dispatch(setProductDetail({}));
      });
  };
};

export const getProductNowDetail = (params) => {
  return (dispatch) => {
    get(PRODUCT_DETAIL_NOW_GET, params)
      .then((res) => {
        if (res.success) {
          const data = res.content;
          dispatch(setProductDetail(data));
        }
      })
      .catch((error) => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取产品详情失败",
          })
        );
        dispatch(setProductDetail({}));
      });
  };
};

export const getProductList = (params, cb) => {
  return (dispatch) => {
    get(PRODUCT_LIST_GET, params)
      .then((res) => {
        if (res.success) {
          const { content } = res;
          cb && cb(content);
          dispatch(
            setProductList({
              list: content.rows,
              total: content.count,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取产品列表失败",
          })
        );
        dispatch(
          setProductList({
            list: [],
            total: 0,
          })
        );
      });
  };
};

export const getSuiteList = (params) => {
  return (dispatch) => {
    get(SUITE_LIST_GET, params)
      .then((res) => {
        if (res.success) {
          const { content } = res;
          dispatch(
            setSuiteList({
              list: content.rows,
              total: content.count,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取套件列表失败",
          })
        );
        dispatch(
          setSuiteList({
            list: [],
            total: 0,
          })
        );
      });
  };
};

export const getCategoryList = (params, cb) => {
  return (dispatch) => {
    get(PRODUCT_CATEGORY_GET, params)
      .then((res) => {
        if (res.success) {
          const data = res.content;
          cb?.(data);
          dispatch(setCategoryList(data));
        }
      })
      .catch((error) => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取产品大类失败",
          })
        );
        dispatch(setCategoryList([]));
      });
  };
};

export const getSubCategoryList = (params, cb) => {
  return (dispatch) => {
    get(PRODUCT_CATEGORY_SUB_LIST_GET, params)
      .then(({ success, content }) => {
        if (success) {
          cb?.(content);
        }
      });
  };
};

export const getProductSuite = (params) => {
  return (dispatch) => {
    get(PRODUCT_SUITE_GET, params)
      .then((res) => {
        if (res.success) {
          const data = res.content;
          dispatch(setProductSuite(data));
        }
      })
      .catch((error) => {
        // dispatch(setMessage({
        //   type: 'error',
        //   msg: '获取产品套件失败',
        // }));
        dispatch(setProductSuite({}));
      });
  };
};

export const getSolutionList = (params) => {
  return (dispatch) => {
    get(SOLUTION_LIST_GET, params)
      .then((res) => {
        if (res.success) {
          const { content } = res;
          dispatch(
            setSolutionList({
              list: content.rows,
              total: content.count,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取列表失败",
          })
        );
        dispatch(
          setSolutionList({
            list: [],
            total: 0
          })
        );
      });
  };
};

export const getSolutionForHome = (params) => {
  return (dispatch) => {
    get(SOLUTION_LIST_GET, params)
      .then((res) => {
        if (res.success) {
          const data = res.content;
          switch (params.category) {
            case "SOLUTION":
              dispatch(setSolutions(data.rows));
              break;
            case "SUCCCASE":
              dispatch(setCases(data.rows));
              break;
            default: break;
          }
        }
      })
      .catch((error) => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取列表失败",
          })
        );
      });
  };
};

export const getSolutionDetail = (params) => {
  return (dispatch) => {
    get(SOLUTION_DETAIL_GET, params)
      .then((res) => {
        if (res.success) {
          const { content } = res;
          dispatch(setSolutionDetail(content));
        }
      })
      .catch((error) => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取详情失败",
          })
        );
        dispatch(setSolutionDetail({}));
      });
  };
};

export const getProductClassifyList = (params) => {
  return (dispatch) => {
    get(PRODUCT_CLASSIFY_LIST_GET, params)
      .then((res) => {
        if (res.success) {
          const { content = {} } = res;
          dispatch(setProductClassifyList({
            list: content.rows,
            total: content.count,
          }));
        }
      })
      .catch((error) => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取产品类型失败",
          })
        );
        dispatch(setProductClassifyList({
          list: [],
          total: 0,
        }));
      });
  };
};

export const getMajorUpgradeList = (params) => {
  return (dispatch) => {
    get(PRODUCT_MAJOR_UPGRADE_LIST_GET, params)
      .then((res) => {
        if (res.success) {
          const data = res.content;
          dispatch(setMajorUpgradeList(data));
        }
      })
      .catch((error) => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取重大升级失败",
          })
        );
        dispatch(setMajorUpgradeList([]));
      });
  };
};

/**
 * 实在不理解为什么还要转一次= =
 * @param {*} params 
 * @returns 
 */
export const getProductChangeList = (params, setLoading) => {
  return (dispatch) => {
    get(PRODUCT_CHANGE_LIST_GET, params)
      .then((res) => {
        setLoading?.(false);
        if (res.success) {
          const data = res.content;
          const { ANNOUNCEMENT, NEW, OLD, PRICE_CHANGE, PROMOTION, MAJOR_UPGRADE, SOFTWARE } = data;
          dispatch(setProjectChangeList({
            ANNOUNCEMENT: {
              list: ANNOUNCEMENT.rows,
              total: ANNOUNCEMENT.count,
            },
            NEW: {
              list: NEW.rows,
              total: NEW.count,
            },
            OLD: {
              list: OLD.rows,
              total: OLD.count,
            },
            PRICE_CHANGE: {
              list: PRICE_CHANGE.rows,
              total: PRICE_CHANGE.count,
            },
            PROMOTION: {
              list: PROMOTION.rows,
              total: PROMOTION.count,
            },
            MAJOR_UPGRADE: {
              list: MAJOR_UPGRADE.rows,
              total: MAJOR_UPGRADE.count,
            },
            SOFTWARE: {
              list: SOFTWARE.rows,
              total: SOFTWARE.count,
            }
          }));
        }
      })
      .catch((error) => {
        setLoading?.(false);
        dispatch(
          setMessage({
            type: "error",
            msg: "获取产品公告信息失败",
          })
        );
        dispatch(setProjectChangeList({
          NEW: {
            list: [],
            total: 0,
          },
          OLD: {
            list: [],
            total: 0,
          },
          PRICE_CHANGE: {
            list: [],
            total: 0,
          },
          PROMOTION: {
            list: [],
            total: 0,
          },
          MAJOR_UPGRADE: {
            list: [],
            total: 0,
          }
        }));
      });
  };
};

export const getPromotionList = (params) => {
  return (dispatch) => {
    get(PRODUCT_PROMOTION_LIST_GET, params)
      .then((res) => {
        if (res.success) {
          const data = res.content;
          dispatch(setPromotionList({
            list: data.rows,
            total: data.total,
          }));
        }
      })
      .catch((error) => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取产品促销列表失败！",
          })
        );
        dispatch(setPromotionList({
          list: [],
          total: 0,
        }));
      });
  };
};

export const getSolutionLevelOne = (params) => {
  return (dispatch) => {
    curl
      .get(SOLUTION_LV_ONE_LIST_GET, params)
      .then((res) => {
        dispatch(setSolutionLevelOne(res));
      });
  };
};

export const getSolutionLevelTwo = (params, cb) => {
  return (dispatch) => {
    curl
      .get(SOLUTION_LV_TWO_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
        dispatch(setSolutionLevelTwo(res));
      });
  };
};

export const getSolutionHistory = (params, cb) => {
  return (dispatch) => {
    curl
      .get(SOLUTION_HISTORY_GET, params)
      .then((res) => {
        cb && cb(res);
        dispatch(setSolutionHistory(res));
      });
  };
};

export const getProductCaseAreaList = (params, cb) => {
  return (dispatch) => {
    curl
      .get(PRODUCT_CASE_AREA_GET, params)
      .then((res) => {
        cb && cb(res);
        dispatch(setProductCaseAreaList(res));
      });
  };
};

export const getShipmentBarcodeList = (params, cb) => {
  return (dispatch) => {
    curl
      .get(SHIPMENT_BARCODE_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

export const getProductLine = (params, cb) => {
  return (dispatch) => {
    curl
      .get(SYSTEM_PRODUCT_LINE_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};
